/* Hoell Editorial-Band: Pin-Parallax des Bildbands, Drift des Massbands,
   Fit-to-width der Display-Zeile, Zeichen-Reveal der grossen Saetze.
   Werte nach dem Teardown von captured.framer.website (docs/entwuerfe/
   captured-teardown.md): Parallax 0,2 x Scroll, Drift 0,074 px/px, Reveal
   4 px / 12 ms Staffel. Dazu fuer das Leistungsraster: Hintergrund-Zoom 1,2 -> 1,0
   beim Hereinscrollen, springende Koernung, aufsteigende Karten ([data-wfeb-rise]).
   Laeuft einmal pro Seite; jede Instanz meldet sich
   ueber [data-hoell-editorial] an, auch nach Horizons Section-Re-Render. */
(function () {
  'use strict';
  if (window.hoellEditorialGeladen) return;
  window.hoellEditorialGeladen = true;

  var doc = document;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: true };
  var instances = [];
  var io = null;

  if (!reduced && 'IntersectionObserver' in window) {
    doc.documentElement.classList.add('wfeb-anim');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
  }

  /* Text in Wort-Spans (nowrap) und Zeichen-Spans (inline-block) zerlegen,
     Markup wie <em> bleibt erhalten. Leerzeichen bleiben Textknoten, damit
     der Umbruch weiter zwischen Woertern passiert. */
  function splitChars(root, counter) {
    Array.prototype.slice.call(root.childNodes).forEach(function (node) {
      if (node.nodeType === 3) {
        var frag = doc.createDocumentFragment();
        node.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
          var word = doc.createElement('span');
          word.className = 'wfeb-word';
          Array.prototype.forEach.call(part, function (ch) {
            var c = doc.createElement('span');
            c.className = 'wfeb-ch';
            c.textContent = ch;
            c.style.transitionDelay = (counter.n * 12) + 'ms';
            counter.n += 1;
            word.appendChild(c);
          });
          frag.appendChild(word);
        });
        root.replaceChild(frag, node);
      } else if (node.nodeType === 1 && !node.classList.contains('wfeb-q')) {
        splitChars(node, counter);
      }
    });
  }

  function setupRise(el) {
    if (!io) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-wfeb-rise]'), function (t) {
      if (t.dataset.rise) return;
      t.dataset.rise = '1';
      io.observe(t);
    });
  }

  /* Koernung: alle ~110 ms an eine zufaellige Stelle springen (Referenz springt
     jeden Frame, das ist fuer eine Shop-Seite zu viel CPU). */
  var grains = [];
  var grainTimer = null;
  function tickGrain() {
    grains = grains.filter(function (g) { return doc.body.contains(g); });
    grains.forEach(function (g) {
      var w = g.offsetWidth * 0.3, h = g.offsetHeight * 0.3;
      g.style.transform = 'translate(' + ((Math.random() - 0.5) * w).toFixed(0) + 'px,' + ((Math.random() - 0.5) * h).toFixed(0) + 'px)';
    });
    if (!grains.length) { clearInterval(grainTimer); grainTimer = null; }
  }
  function setupGrain(el) {
    if (reduced) return;
    Array.prototype.forEach.call(el.querySelectorAll('[data-wfeb-grain]'), function (g) {
      if (grains.indexOf(g) === -1) grains.push(g);
    });
    if (grains.length && !grainTimer) grainTimer = setInterval(tickGrain, 110);
  }

  function setupReveal(el) {
    var targets = el.querySelectorAll('[data-wfeb-reveal]');
    if (!io) return;
    Array.prototype.forEach.call(targets, function (t) {
      if (t.dataset.split) return;
      t.dataset.split = '1';
      splitChars(t, { n: 0 });
      t.classList.add('wfeb-split');
      io.observe(t);
    });
  }

  /* Display-Zeile auf die Breite ihres Elternteils skalieren (Referenz:
     SVG-foreignObject-Fit). 100 px messen, proportional hochrechnen,
     Obergrenze aus data-max. */
  function fitLine(n) {
    var parent = n.parentElement;
    var pcs = window.getComputedStyle(parent);
    var box = parent.clientWidth - parseFloat(pcs.paddingLeft || 0) - parseFloat(pcs.paddingRight || 0);
    if (!(box > 0)) return;
    n.style.fontSize = '100px';
    var w = n.scrollWidth;
    if (!w) return;
    var max = parseFloat(n.dataset.max || '600');
    var size = Math.min(max, (100 * box / w) * 0.985);
    n.style.fontSize = size.toFixed(2) + 'px';
    var copy = n.closest('[data-wfeb-copy]');
    if (copy) copy.style.setProperty('--wfeb-display', size.toFixed(2) + 'px');
  }

  function frame(inst) {
    var el = inst.el;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    if (inst.ruler) {
      /* Weg, den die Section seit ihrem Eintritt ins Sichtfeld zurueckgelegt hat.
         Die Bedingung prueft nur, OB es ein Massband gibt — haengt sie zusaetzlich an der
         Geschwindigkeit, fehlt bei Drift 0 auch der Startversatz und das Band springt. */
      var travelled = Math.max(0, vh - r.top);
      var tx = inst.rulerStart - travelled * inst.rulerSpeed;
      /* Auf ganze GERAETEpixel runden, nicht auf CSS-Pixel: bei 125 % Anzeige-Skalierung
         ist ein CSS-Pixel 1,25 Geraetepixel, eine Rundung auf CSS-Pixel trifft das Raster
         also gerade nicht. Sonst wandert das Strichmuster beim Scrollen. */
      var dpr = window.devicePixelRatio || 1;
      inst.ruler.style.transform = 'translateX(' + (Math.round(tx * dpr) / dpr) + 'px)';
    }
    if (inst.zooms.length && !reduced) {
      /* 1,2 beim Eintritt (Oberkante des Kastens unten im Sichtfeld) -> 1,0, wenn der
         Kasten ein knappes Drittel seiner Hoehe nach oben gewandert ist */
      inst.zooms.forEach(function (z) {
        var host = z.parentElement || z;
        var hr = host.getBoundingClientRect();
        var lead = hr.height * 0.3;
        var p = (hr.top + lead) / (vh + lead);
        p = Math.max(0, Math.min(1, p));
        z.style.transform = 'scale(' + (1 + inst.zoom * p).toFixed(4) + ')';
      });
    }
    if (inst.cardzooms.length && !reduced) {
      /* Portfolio-Karten: das Bild startet auf 110 % und laeuft auf 100 %, waehrend der
         Rahmen vom unteren Bildschirmrand bis zur vollen Sichtbarkeit wandert. Gemessen
         am Vorbild (Rahmen 654 x 464 bei 900 px Fensterhoehe): Oberkante 997 -> 1,1 ·
         697 -> 1,059 · 397 -> 1,003 · darueber 1,0. Das ergibt
         p = (Oberkante + Rahmenhoehe - Fensterhoehe) / Rahmenhoehe, auf 0..1 begrenzt. */
      inst.cardzooms.forEach(function (frame) {
        var img = frame.querySelector('img');
        if (!img) return;
        var fr = frame.getBoundingClientRect();
        if (!fr.height) return;
        var p = (fr.top + fr.height - vh) / fr.height;
        p = Math.max(0, Math.min(1, p));
        img.style.transform = 'scale(' + (1 + inst.cardzoom * p).toFixed(4) + ')';
      });
    }
    if (inst.drifts.length && !reduced) {
      /* Galerie-Reihen: gegenlaeufig, 0,03 px je Pixel Abstand zur Bildmitte, max. 80 */
      inst.drifts.forEach(function (d) {
        var dir = parseFloat(d.dataset.wfebDrift || '1') || 1;
        var dr = d.getBoundingClientRect();
        var tx = dir * 0.03 * (dr.top - vh * 0.5);
        tx = Math.max(-80, Math.min(80, tx));
        d.style.transform = 'translateX(' + tx.toFixed(1) + 'px)';
      });
    }
    if (inst.rotates.length && !reduced) {
      /* Rad: 0,0255 Grad je Scroll-Pixel seit Eintritt ins Sichtfeld (Referenz) */
      inst.rotates.forEach(function (w) {
        var wr = w.getBoundingClientRect();
        var deg = 90 + 0.0255 * Math.max(0, vh - wr.top);
        w.style.transform = 'translate(-50%, -50%) rotate(' + deg.toFixed(2) + 'deg)';
      });
    }
    if (inst.band) {
      if (inst.pin && inst.parallax && desktop.matches && !reduced) {
        /* Rueckweichen erst, wenn die Flaeche das Band zu ueberfahren beginnt —
           sonst klafft waehrend der Haltestrecke ein Spalt unter dem Band */
        var sheetTop = inst.sheet ? inst.sheet.getBoundingClientRect().top : r.top + inst.band.offsetHeight;
        var passed = Math.max(0, vh - sheetTop);
        inst.band.style.transform = 'translateY(' + (-passed * inst.parallax).toFixed(1) + 'px)';
      } else if (inst.band.style.transform) {
        inst.band.style.transform = '';
      }
    }
  }

  function setup(el) {
    if (el.dataset.wfebInit) return;
    el.dataset.wfebInit = '1';
    var inst = {
      el: el,
      band: el.querySelector('[data-wfeb-band]'),
      ruler: el.querySelector('[data-wfeb-ruler]'),
      sheet: el.querySelector('[data-wfeb-sheet]'),
      fits: el.querySelectorAll('[data-wfeb-fit]'),
      pin: el.dataset.pin === 'true',
      parallax: parseFloat(el.dataset.parallax || '0') / 100,
      rulerSpeed: parseFloat(el.dataset.rulerSpeed || '0') / 100,
      rulerStart: parseFloat(el.dataset.rulerStart || '0'),
      zooms: Array.prototype.slice.call(el.querySelectorAll('[data-wfeb-zoom]')),
      drifts: Array.prototype.slice.call(el.querySelectorAll('[data-wfeb-drift]')),
      rotates: Array.prototype.slice.call(el.querySelectorAll('[data-wfeb-rotate]')),
      zoom: parseFloat(el.dataset.zoom || '20') / 100,
      cardzooms: Array.prototype.slice.call(el.querySelectorAll('[data-wfeb-cardzoom]')),
      cardzoom: parseFloat(el.dataset.cardzoom || '10') / 100
    };
    instances.push(inst);
    /* Intro-Choreografie: das Band bekommt .is-in, sobald es ins Sichtfeld kommt —
       die Startzustaende und Uebergaenge stehen im CSS der Section. */
    var intro = el.querySelector('[data-wfeb-intro]');
    if (intro) { if (io) io.observe(intro); else intro.classList.add('is-in'); }
    Array.prototype.forEach.call(inst.fits, fitLine);
    /* Der Theme-Editor rendert die Section neu und aendert die Vorschaubreite,
       ohne dass ein window-resize kommt — deshalb die Zeile an ihrem Container
       beobachten, nicht nur am Fenster. */
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        Array.prototype.forEach.call(inst.fits, fitLine);
      });
      Array.prototype.forEach.call(inst.fits, function (n) { if (n.parentElement) ro.observe(n.parentElement); });
      inst.ro = ro;
    }
    setupReveal(el);
    setupRise(el);
    setupGrain(el);
    frame(inst);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      instances.forEach(frame);
      ticking = false;
    });
  }
  function onResize() {
    instances.forEach(function (inst) {
      Array.prototype.forEach.call(inst.fits, fitLine);
      frame(inst);
    });
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    Array.prototype.forEach.call(root.querySelectorAll('[data-hoell-editorial]'), setup);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { scan(doc); });
  } else {
    scan(doc);
  }
  /* Schrift laedt nach: Fit danach einmal nachziehen */
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(onResize);
  if (doc.fonts && doc.fonts.addEventListener) doc.fonts.addEventListener('loadingdone', onResize);
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  doc.addEventListener('shopify:section:load', function (e) {
    instances = instances.filter(function (inst) { return doc.body.contains(inst.el); });
    scan(e.target);
    onResize();
  });
  doc.addEventListener('shopify:section:unload', function () {
    instances = instances.filter(function (inst) { return doc.body.contains(inst.el); });
  });
})();
